import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Tabs,
  Tab,
  Button,
  Form,
  Badge,
  Image,
  Breadcrumb,
  Modal,
} from 'react-bootstrap';
import { IoCameraOutline } from "react-icons/io5";
import Base from '../Base';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { MdDoubleArrow } from "react-icons/md";
import { FaCheck, FaCheckCircle, FaEdit, FaEye, FaPlus, FaSave, FaTimes, FaTrash, FaUserCircle } from 'react-icons/fa';
import employeeFormConfig, { apiService, EXPValidationRules, kycValidationRules, employeeApprovalService, extractDropdownValue } from './employeeFormConfig';
import { useDispatch, useSelector } from 'react-redux';
import { getRoles, getSingleUser } from '../../slices/userReducer';
import Loader from '../common/Loader';
import toast from "react-hot-toast";
import DynamicModal from './DynamicModal';
import { FaUser, FaGavel } from 'react-icons/fa';
import { MdDoneAll } from 'react-icons/md';
import { truncate } from 'lodash';
import { truncateText, truncateTextOnly } from '../../utils';
import { extractErrorMessage } from '../../constants/common';
import { toastService } from "../../utils/toastService"
import DynamicCreateModal from '../common/DynamicCreateModal';
function Employees() {
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    onConfirm: null,
    message: '',
  });
  const navigate = useNavigate();
  const [showApprovalWorkflow, setShowApprovalWorkflow] = useState(true);
  const [errors, setErrors] = useState({});
  const [kycErrors, setKycErrors] = useState({});
  const [expErrors, setexpErrors] = useState({});
  const [activeTab, setActiveTab] = useState('general');
  const fileInputRef = useRef();
  const [saving, setSaving] = useState({});
  const { roles, user, loading } = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const { user_id } = useParams()
  const [editMode, setEditMode] = useState({
    employeeInfo: false,
    personalInfo: false,
    employeeIdentity: false,
    joiningDetails: false,
    address: false,
    contacts: false,
    backgroundCheck: false,
    remarks: false
  });
  const [kycList, setKycList] = useState([]);
  const [showKycForm, setShowKycForm] = useState(false);
  const [editingKycId, setEditingKycId] = useState(null);
  const [kycFormData, setKycFormData] = useState({
    id_card_type: '',
    photo: null,
    id_card_number: ''
  });
  // Main employee data
  const [employeeData, setEmployeeData] = useState({});
  const [originalData, setOriginalData] = useState({});

  const [experienceList, setExperienceList] = useState([]);
  const [showExperienceForm, setShowExperienceForm] = useState(false);
  const [editingExperienceId, setEditingExperienceId] = useState(null);
  const [experienceFormData, setExperienceFormData] = useState({
    job_title: '',
    organization: '',
    type: '',
    start_date: '',
    end_date: '',
    total_years: ''
  });

  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verifyingExperienceId, setVerifyingExperienceId] = useState(null);
  const [verifyingExperience, setVerifyingExperience] = useState(null);
  const [companyFields, setCompanyFields] = useState({
    company_user_id: '',
    company_email: '',
  });
  const [companyFieldsLoaded, setCompanyFieldsLoaded] = useState(false);
  const [companyFieldsEdited, setCompanyFieldsEdited] = useState({
    company_user_id: false,
    company_email: false,
  });
  // Dropdown data
  const [dropdownData, setDropdownData] = useState({
    jobTitles: [],
    roles: []
  });

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createModalData, setCreateModalData] = useState({
    type: '',
    label: '',
    apiKey: '',
    fieldKey: '',
    name: ''
  });
  const [createModalErrors, setCreateModalErrors] = useState({});
  const [creatingItem, setCreatingItem] = useState(false);
  const [KYCTypesList, setKYCTypesList] = useState([]);
  const [loadingKYCTypesList, setLoadingKYCTypesList] = useState(false);
  const kycDropDownCreate = {
    name: 'KYC Type',
    placeholder: 'Select KYC Type',
    type: 'select',
    label: 'KYC Type',
    apiEndpoint: '/api/v1/user/kyc/type/create', // Adjusted for URL standard
    fields: [
      {
        key: 'label',
        label: 'KYC Type',
        required: true,
        maxLength: 80,
        placeholder: 'Enter KYC Type'
      }
    ]
  };
  const handleShowCreateModal = (type, label, apiKey, fieldKey) => {
    setCreateModalData({
      type,
      label: label,
      apiKey,
      fieldKey,
      name: ''
    });
    setCreateModalErrors({});
    setShowCreateModal(true);
  };
  const handleCreateModalSubmit = async () => {
    setCreateModalErrors({});

    if (!createModalData.name.trim()) {
      setCreateModalErrors({ name: 'Name is required' });
      return;
    }

    try {
      setCreatingItem(true);
      const newItem = await handleCreateDropdownItem(createModalData.apiKey, createModalData.name.trim());
      if (newItem) {
        if (createModalData.apiKey === "jobTitles") {
          handleInputChange(createModalData.fieldKey, newItem.id);
          toast.success(`${createModalData.label} created successfully`);
        } else if (createModalData.apiKey === "KYC Type") {
          const newCategory = newItem?.data;
          setKYCTypesList(prev => {
            const isAlreadyPresent = prev.some(item => item.id === newCategory.id);
            if (!isAlreadyPresent) {
              return [...prev, newCategory];
            }
            return prev;
          });
          handleKycInputChange('id_card_type', newCategory?.id)
          toast.success(newItem?.message || "Created");
        }
        handleCreateModalClose();
      }
    } catch (error) {
      console.error('Error creating item:', error);
      toast.error(`Failed to create ${createModalData.label}`);
    } finally {
      setCreatingItem(false);
    }
  };

  const handleCreateModalClose = () => {
    setShowCreateModal(false);
    setCreateModalData({
      type: '',
      label: '',
      apiKey: '',
      fieldKey: '',
      name: ''
    });
    setCreateModalErrors({});
    setCreatingItem(false);
  };

  useEffect(() => {
    if (employeeData && Object.keys(employeeData).length > 0) {
      setCompanyFields({
        company_user_id: employeeData?.onboarding_status?.company_user_id || '',
        company_email: employeeData?.onboarding_status?.company_email || '',
      });
      setCompanyFieldsLoaded(true);
    }
  }, [employeeData]);

  useEffect(() => {
    dispatch(getRoles());
    dispatch(getSingleUser(user_id));
    setEmployeeData(user);
    setOriginalData(user);
  }, [dispatch, user_id]);

  useEffect(() => {
    const loadAllDropdownData = async () => {
      try {
        // Load job titles
        const jobTitles = await apiService.getJobTitles();

        // Update dropdown data with both roles and jobTitles
        setDropdownData({
          jobTitles: jobTitles || [],
          roles: roles || []
        });
      } catch (error) {
        console.error('Error loading dropdown data:', error);
        // Set roles even if jobTitles fails
        setDropdownData(prev => ({
          ...prev,
          roles: roles || []
        }));
      }
    };

    // Load data when component mounts and when roles change
    loadAllDropdownData();
  }, [roles]);

  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      setEmployeeData(user);
      setOriginalData(user);
    }
  }, [user]);

  useEffect(() => {
    if (employeeData?.id) {
      fetchKycList();
      fetchExperienceList();
      fetchKYCTypes()

    }
  }, [employeeData?.id]);

  const validateField = (key, value, validation, required) => {
    if ((key === "company_user_id" || key === "company_email") && employeeData?.onboarding_status?.status === 0) {
      return null;
    }

    if (required && !value) {
      return 'This field is required.';
    }

    // Only validate pattern if field has a value
    if (value && validation?.pattern && !validation.pattern.test(value)) {
      return validation.message;
    }

    return null; // No error
  };

  const fetchKycList = async () => {
    try {
      const response = await apiService.listKyc(employeeData?.id);
      setKycList(response.data.lists || []);
    } catch (error) {
      console.error('Error fetching KYC list:', error);
      // toast.error('Failed to fetch KYC records');
    }
  };

  const fetchKYCTypes = async () => {
    setLoadingKYCTypesList(true);
    try {
      const response = await apiService.listKycTypes();
      setKYCTypesList(response.data);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoadingKYCTypesList(false);
    }
  };

  const handleKycInputChange = (key, value) => {
    setKycFormData(prev => {
      const updatedData = { ...prev, [key]: value };

      // Clear error for id_card_type when a value is selected
      if (key === 'id_card_type' && value) {
        setKycErrors(prevErrors => ({
          ...prevErrors,
          id_card_type: ''  // Clear the error
        }));
      }

      // Only validate id_card_number (existing logic)
      if (key === 'id_card_number') {
        const selectedType = updatedData.id_card_type;
        const rule = kycValidationRules[selectedType];

        if (rule && !rule.pattern.test(value)) {
          setKycErrors(prevErrors => ({
            ...prevErrors,
            [key]: rule.message
          }));
        } else {
          setKycErrors(prevErrors => ({
            ...prevErrors,
            [key]: ''
          }));
        }
      }

      // Also validate when id_card_type changes (existing logic)
      if (key === 'id_card_type' && updatedData.id_card_number) {
        const rule = kycValidationRules[value];
        if (rule && !rule.pattern.test(updatedData.id_card_number)) {
          setKycErrors(prevErrors => ({
            ...prevErrors,
            id_card_number: rule.message
          }));
        } else {
          setKycErrors(prevErrors => ({
            ...prevErrors,
            id_card_number: ''
          }));
        }
      }

      return updatedData;
    });
  };

  const handleKycFileChange = (e) => {
    const file = e.target.files[0];
    setKycFormData(prev => ({
      ...prev,
      photo: file
    }));

    // Clear photo error when a file is selected
    if (file) {
      setKycErrors(prevErrors => ({
        ...prevErrors,
        photo: ''  // Clear the error
      }));
    }
  };

  const handleKycSave = async () => {
    setKycErrors({});
    try {
      // Validate required fields
      const errors = {};

      if (!kycFormData.id_card_type) {
        errors.id_card_type = 'KYC type is required';
      }

      if (!kycFormData.id_card_number) {
        errors.id_card_number = 'KYC ID number is required';
      }

      if (!editingKycId && !kycFormData.photo) {
        errors.photo = 'KYC file is required';
      }

      if (Object.keys(errors).length > 0) {
        setKycErrors(errors);
        toastService.error('Please fill all required fields');
        return;
      }

      setSaving(prev => ({ ...prev, employeeIdentity: true }));

      if (editingKycId) {
        // Update existing KYC
        await apiService.updateKyc(employeeData.id, editingKycId, {
          ...kycFormData,
          is_photo_update: kycFormData.photo ? true : false
        });
        toast.success('KYC updated successfully');
      } else {
        // Create new KYC
        await apiService.insertKyc(employeeData.id, kycFormData);
        toast.success('KYC added successfully');
      }

      // Reset form and refresh list
      setKycFormData({
        id_card_type: '',
        photo: null,
        id_card_number: ''
      });
      setShowKycForm(false);
      setEditingKycId(null);
      await fetchKycList();

    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setSaving(prev => ({ ...prev, employeeIdentity: false }));
    }
  };

  const handleKycEdit = (kyc) => {
    setKycFormData({
      id_card_type: kyc.card_type?.id,
      photo: null, // Don't pre-fill file input
      id_card_number: kyc?.id_card_number
    });
    setEditingKycId(kyc.id);
    setShowKycForm(true);
  };

  const handleKycDelete = (kycId) => {
    setShowKycForm(false);
    setConfirmModal({
      show: true,
      message: "Are you sure you want to delete this KYC record?",
      onConfirm: async () => {
        try {
          await apiService.deleteKyc(employeeData.id, kycId);
          setKycFormData({
            id_card_type: null,
            photo: null, // Don't pre-fill file input
            id_card_number: null
          });
          setEditingKycId(null);
          toast.success('KYC deleted successfully');
          await fetchKycList();
        } catch (error) {
          const errorMessage = extractErrorMessage(error);
          toast.error(errorMessage);
        }
      }
    });
  };

  const handleKycCancel = () => {
    setKycErrors({})
    setKycFormData({
      id_card_type: '',
      photo: null,
      id_card_number: ''
    });
    setShowKycForm(false);
    setEditingKycId(null);
  };
  // Handle edit mode toggle
  const handleEditToggle = (section) => {
    setErrors({})
    setKycErrors({})

    if (editMode[section]) {
      // Cancel edit - restore original data
      const sectionFields = employeeFormConfig[section]?.fields || [];
      const restoredData = {};

      // Handle company fields separately (they use companyFields state)
      if (section === 'officialInfo') {
        setCompanyFields({
          company_user_id: originalData?.onboarding_status?.company_user_id || '',
          company_email: originalData?.onboarding_status?.company_email || '',
        });

        // Reset the edited flags
        setCompanyFieldsEdited({
          company_user_id: false,
          company_email: false,
        });
      }

      // Handle regular fields
      sectionFields.forEach(field => {
        if (field.key === 'personal_email') {
          // Special handling for personal_email to restore nested structure
          restoredData.personal_email = originalData.personal_email;
          restoredData.onboarding_status = {
            ...employeeData.onboarding_status,
            temp_username: originalData.onboarding_status?.temp_username || originalData.personal_email
          };
        } else if (field.key !== 'company_user_id' && field.key !== 'company_email') {
          // Skip company fields as they're handled separately above
          restoredData[field.key] = originalData[field.key];
        }
      });

      // Apply restored data to employeeData
      if (Object.keys(restoredData).length > 0) {
        setEmployeeData(prev => ({ ...prev, ...restoredData }));
      }
    }

    // Toggle edit mode
    setEditMode(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Handle input changes
  const handleInputChange = (key, value, fieldConfig = null) => {
    if (key === "personal_email") {
      setEmployeeData(prev => ({
        ...prev,
        personal_email: value,  // Store for payload
        onboarding_status: {
          ...prev.onboarding_status,
          temp_username: value  // Update nested structure for display
        }
      }));
    } else {
      // Handle regular fields
      setEmployeeData(prev => ({ ...prev, [key]: value }));
    }

    // Run validation only if fieldConfig is present
    if (fieldConfig) {
      const errorMsg = validateField(
        key,
        value,
        fieldConfig.validation || null,
        fieldConfig.required || false
      );

      setErrors(prev => ({ ...prev, [key]: errorMsg }));
    }
  };

  const handleCompanyInputChange = (key, value, fieldConfig = null) => {
    setCompanyFields(prev => ({
      ...prev,
      [key]: value
    }));

    setCompanyFieldsEdited(prev => ({
      ...prev,
      [key]: true
    }));

    // Validation
    if (fieldConfig) {
      const errorMsg = validateField(
        key,
        value,
        fieldConfig.validation || null,
        fieldConfig.required || false
      );

      setErrors(prev => ({
        ...prev,
        [key]: errorMsg
      }));
    }
  };

  const handleSave = async (section) => {
    try {
      setSaving(prev => ({ ...prev, [section]: true }));

      const sectionConfig = employeeFormConfig[section];
      const sectionFields = sectionConfig?.fields || [];

      let sectionHasError = false;
      const newErrors = {};

      const getFieldValue = (key) => {
        if (key === "company_user_id" || key === "company_email") {
          return companyFields[key];
        }
        if (key === "personal_email") {
          return employeeData?.onboarding_status?.temp_username;
        }
        return employeeData[key];
      };

      // Then in handleSave:
      for (const field of sectionFields) {
        const { key, required, validation } = field;
        const value = getFieldValue(key);

        const errorMsg = validateField(key, value, validation, required);
        if (errorMsg) {
          sectionHasError = true;
          newErrors[key] = errorMsg;
        }
      }

      if (sectionHasError) {
        setErrors(prev => ({ ...prev, ...newErrors }));
        toast.error("Please fix the errors before saving.");
        return;
      }
      if (section === "officialInfo") {
        try {
          const res = await employeeApprovalService.updateCompanyInfo(
            employeeData.id,
            companyFields.company_email,
            companyFields.company_user_id
          );

          if (res?.status === 'success') {
            setOriginalData(prev => ({
              ...prev,
              onboarding_status: {
                ...prev.onboarding_status,
                company_email: companyFields.company_email,
                company_user_id: companyFields.company_user_id
              }
            }));
            setEditMode(prev => ({
              ...prev,
              [section]: false
            }));
            toast.success(res?.message || "Company details updated successfully.");
            return;
          }
        } catch (error) {
          const errorMessage = extractErrorMessage(error);
          toast.error(errorMessage);
          return;
        }
      }
      // Construct data to save (pick only keys in this section)
      const dataToSave = {};
      for (const field of sectionFields) {
        const key = field.key;
        if (key === "job_title") {
          const jobTitleValue = employeeData[key];
          dataToSave[key] = (jobTitleValue && typeof jobTitleValue === 'object') ? jobTitleValue.id : jobTitleValue;
        } else if ((key === "personal_email")) {
          dataToSave[key] = employeeData?.onboarding_status.temp_username || null;
        } else {
          dataToSave[key] = employeeData[key] || null;
        }
      }

      const result = await apiService.updateEmployeeData(user_id, dataToSave);

      if (result?.type === "success") {
        setOriginalData({ ...employeeData });
        setEditMode(prev => ({
          ...prev,
          [section]: false
        }));
        toast.success("Updated successfully");
      } else {
        toast.error(result?.message || "Update failed.");
      }
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setSaving(prev => ({ ...prev, [section]: false }));
    }
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      toast.error("Invalid file type. Only JPG, JPEG, and PNG are allowed.");
      return;
    }

    try {
      const res = await apiService.uploadProfilePhoto(employeeData?.id, file);
      console.log(res)
      if (res?.type === "success") {
        toast.success(res?.message || "Photo updated successfully");
      }
      setEmployeeData((prev) => ({
        ...prev,
        photo: res?.photo || URL.createObjectURL(file),
      }));
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    }
  };

  // Handle dropdown creation
  const handleCreateDropdownItem = async (type, name) => {
    try {
      let newItem;
      if (type === 'jobTitles') {
        newItem = await apiService.createJobTitle(name);
        setDropdownData(prev => ({
          ...prev,
          jobTitles: [...prev.jobTitles, newItem]
        }));
      } else if (type === "KYC Type") {
        newItem = await apiService.createKYCType(name);
      }
      return newItem;
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    }
  };

  // Render field component
  const renderField = (fieldConfig, section) => {
    const { key, label, type, options, apiKey, required } = fieldConfig;
    const onboarding_status = employeeData?.onboarding_status || {};
    const value = extractDropdownValue(key, employeeData[key], 'id');
    const onboarding_value = onboarding_status[key];
    const isEditing = editMode[section];
    const labelElement = (
      <p className="fw-medium mb-1">
        {label} {required && <span className="text-danger">*</span>}
      </p>
    );

    const renderEditField = () => {
      switch (type) {
        case 'select':
          return (
            <>
              <Form.Select
                size="md"
                value={value || ''}
                isInvalid={!!errors[key]}
                onChange={(e) => handleInputChange(key, e.target.value, fieldConfig)}
              >
                <option value="">Select...</option>
                {options?.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors[key]}
              </Form.Control.Feedback>
            </>
          );

        case 'dropdown':
          return (
            <div className="d-flex">
              <Form.Select
                size="md"
                value={value || ''}
                isInvalid={!!errors[key]}
                onChange={(e) => handleInputChange(key, e.target.value, fieldConfig)}
                className="me-2"
              >
                <option value="">Select...</option>
                {dropdownData[apiKey]?.map((item) => (
                  <option key={item.id} value={item.id}>{truncateTextOnly(item.name, 80)}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors[key]}
              </Form.Control.Feedback>
              {key === 'job_title' && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className='no-hover'
                  onClick={() => handleShowCreateModal('dropdown', label, apiKey, key)}
                >
                  <FaPlus />
                </Button>
              )}
            </div>
          );

        case 'textArea':
          return (
            <>
              <Form.Control
                as="textarea"
                rows={3}
                value={value || ''}
                isInvalid={!!errors[key]}
                onChange={(e) => handleInputChange(key, e.target.value, fieldConfig)}
                maxLength={250}
              />
              <Form.Control.Feedback type="invalid">
                {errors[key]}
              </Form.Control.Feedback>
            </>
          );

        case 'text':
        case 'email':
        case 'date':
          if (key === 'username') {
            return (
              <Form.Control
                size="md"
                type="text"
                value={employeeData?.email || ''}
                disabled
                maxLength={100}
                onChange={(e) => handleInputChange(key, e.target.value)}
              />
            );
          } else if (key === "approval_date") {
            return (
              <Form.Control
                size="md"
                type="date"
                value={onboarding_status.approval_date || ''}
                disabled
                onChange={(e) => handleInputChange(key, e.target.value)}
              />
            );
          } else if (key === "personal_email") {
            return (
              <>
                <Form.Control
                  size="md"
                  type="email"
                  value={employeeData.onboarding_status?.temp_username || ''}
                  isInvalid={!!errors[key]}
                  onChange={(e) => handleInputChange(key, e.target.value, fieldConfig)}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[key]}
                </Form.Control.Feedback>
              </>
            );
          } else if ((key === "company_user_id" || key === "company_email") && onboarding_status?.status !== 0) {
            return (
              <>
                <Form.Control
                  size="md"
                  type={type}
                  value={companyFields[key] || ''}
                  isInvalid={!!errors[key]}
                  onChange={(e) => handleCompanyInputChange(key, e.target.value, fieldConfig)}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[key]}
                </Form.Control.Feedback>
              </>
            );
          } else {
            return (
              <>
                <Form.Control
                  size="md"
                  type={type}
                  value={value || ''}
                  maxLength={100}
                  isInvalid={!!errors[key]}
                  disabled={["company_user_id", "company_email", "email"].includes(key)}
                  onChange={(e) => handleInputChange(key, e.target.value, fieldConfig)}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[key]}
                </Form.Control.Feedback>
              </>
            );
          }

        default:
          return null;
      }
    };

    const renderReadOnlyField = () => {
      switch (key) {
        case 'username':
          return employeeData?.email || '-';

        case 'personal_email':
          return onboarding_status?.temp_username || '-';

        case 'job_title':
          const jobTitleValue = employeeData['job_title'];
          let title;
          if (jobTitleValue && typeof jobTitleValue === 'object') {
            title = jobTitleValue.job_title;
          } else if (jobTitleValue) {
            const jobTitleItem = dropdownData.jobTitles?.find(item => item.id == jobTitleValue);
            title = jobTitleItem?.job_title || jobTitleItem?.name;
          }
          return title || '-';

        case 'company_user_id':
          return companyFields[key] || '-';

        case 'company_email':
          return companyFields[key] || '-';

        case 'approval_date':
          return onboarding_value || '-';

        default:
          if (type === 'dropdown') {
            return dropdownData[apiKey]?.find(item => item.id == value)?.name || '-';
          }
          return value || '-';
      }
    };

    return (
      <Col xs={12} sm={6} lg={3} className="mb-3" key={key}>
        <div>
          {labelElement}
          {isEditing ? (
            renderEditField()
          ) : (
            <p className="fw-medium text-muted mb-0 p-2 rounded border">
              {truncateText(renderReadOnlyField(), 50)}
            </p>
          )}
        </div>
      </Col>
    );
  };


  // Render section
  const renderSection = (sectionKey) => {
    const config = employeeFormConfig[sectionKey];
    if (!config) return null;
    if (sectionKey === "officialInfo" && employeeData?.onboarding_status?.status === 0) return null;

    // Determine header content
    const isWarningNeeded =
      sectionKey === "officialInfo" &&
      companyFieldsLoaded &&
      (!companyFields.company_email || !companyFields.company_user_id);
    return (
      <div className="mb-1">
        {renderSectionHeader(
          <>
            {config.title}{' '}
            {isWarningNeeded && (
              <span className="text-danger fw-medium ms-2">
                (Fill these fields before permanent approval)
              </span>
            )}
          </>,
          sectionKey
        )}
        <Row>
          {config.fields.map(field => renderField(field, sectionKey))}
        </Row>
      </div>
    );
  };

  const renderEmployeeIdentitySection = () => (
    <div className="mb-5">
      {renderSectionHeader('Employee Identity', 'employeeIdentity', true)}

      {/* KYC Form - Show when adding/editing */}
      {showKycForm && (
        <Card className="mb-3">
          <Card.Body>
            <h6 className="mb-3 text-primary">{editingKycId ? 'Edit KYC Record' : 'Add New KYC Record'}</h6>
            <Row>
              <Col xs={12} sm={6} lg={4} className="mb-3">
                <Form.Label className="fw-medium">
                  KYC Type <span className="text-danger">*</span>
                </Form.Label>
                <div className="d-flex">
                  <Form.Select
                    value={kycFormData.id_card_type}
                    isInvalid={!!kycErrors.id_card_type}
                    onChange={(e) => handleKycInputChange('id_card_type', e.target.value)}
                  >
                    <option value="">Select KYC Type...</option>

                    {Array.isArray(KYCTypesList) && KYCTypesList.length > 0 ? (
                      KYCTypesList.map(type => (
                        <option key={type.id} value={type.id}>
                          {truncateTextOnly(type.label, 50)}
                        </option>
                      ))
                    ) : !loadingKYCTypesList ? (
                      <option value="" disabled>
                        No KYC Types Found
                      </option>
                    ) : null}
                  </Form.Select>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className='no-hover ml-2'
                    onClick={() => handleShowCreateModal(
                      'dropdown',
                      kycDropDownCreate.fields[0].label,
                      kycDropDownCreate.name,
                      kycDropDownCreate.fields[0].key
                    )}
                  >
                    <FaPlus />
                  </Button>
                </div>
                {kycErrors.id_card_type && (
                  <Form.Text className="text-danger">{kycErrors.id_card_type}</Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="mb-3">
                <Form.Label className="fw-medium">
                  Upload KYC File <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*,.pdf"
                  onChange={handleKycFileChange}
                  isInvalid={!!kycErrors.photo}
                />
                {kycErrors.photo && (
                  <Form.Text className="text-danger">{kycErrors.photo}</Form.Text>
                )}
                {editingKycId && (
                  <Form.Text className="text-muted">
                    Leave empty to keep existing file
                  </Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="mb-3">
                <Form.Label className="fw-medium">
                  KYC ID Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={kycFormData.id_card_number}
                  onChange={(e) => handleKycInputChange('id_card_number', e.target.value)}
                  placeholder="Enter ID number"
                  isInvalid={!!kycErrors.id_card_number}
                />
                {kycErrors.id_card_number && (
                  <Form.Text className="text-danger">{kycErrors.id_card_number}</Form.Text>
                )}
              </Col>
            </Row>

            <div className="d-flex gap-2">
              <Button
                variant="primary"
                size="sm"
                onClick={handleKycSave}
                disabled={saving.employeeIdentity || Object.values(kycErrors).some(error => error)}
                style={{ width: '100px', fontWeight: "bold" }}
              >
                {saving.employeeIdentity ? 'Saving...' : (editingKycId ? 'Update' : 'Save')}
              </Button>
              <Button
                variant="secondary"
                size="sm"
                onClick={handleKycCancel}
                disabled={saving.employeeIdentity}
                style={{ width: '100px', fontWeight: "bold" }}
              >
                Cancel
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* KYC List - Show existing records */}
      {kycList.length > 0 ? (
        <div>
          {kycList.map((kyc, index) => (
            <Card key={kyc.id} className="mb-3">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="mb-0 text-primary">KYC Record: {index + 1}</h6>
                  <div className="d-flex gap-2">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleKycEdit(kyc)}
                      className="d-flex align-items-center no-hover"
                    >
                      <FaEdit className="me-1" />
                      <span>Edit</span>
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleKycDelete(kyc.id)}
                      className="d-flex align-items-center no-hover"
                    >
                      <FaTrash className="me-1" />
                      <span>Delete</span>
                    </Button>
                  </div>
                </div>

                <Row>
                  <Col xs={12} sm={6} lg={4} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">KYC Type</p>
                      <p className="fw-medium text-muted mb-0 p-2 rounded border">
                        {kyc.card_type?.label || '-'}
                      </p>
                    </div>
                  </Col>

                  <Col xs={12} sm={6} lg={4} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">KYC File</p>
                      <div className="p-2 rounded border">
                        {kyc.photo ? (
                          <a
                            href={kyc.photo}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary text-decoration-none d-inline-flex align-items-center"
                          >
                            <FaEye className="me-1" />
                            <span>View File</span>
                          </a>
                        ) : (
                          <span className="text-muted">No file uploaded</span>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} sm={6} lg={4} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">KYC ID Number</p>
                      <p className="fw-medium text-muted mb-0 p-2 rounded border">
                        {kyc.id_card_number || '-'}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </div>
      ) : (
        !showKycForm && (
          <div className="text-center py-4">
            <Button
              variant="outline-primary"
              onClick={() => setShowKycForm(true)}
              className="d-inline-flex align-items-center no-hover"
            >
              <FaPlus className="me-2" />
              <span>Add KYC Record</span>
            </Button>
          </div>
        )
      )}
    </div>
  );

  const fetchExperienceList = async () => {
    try {
      const response = await apiService.listExperience(employeeData.id);
      setExperienceList(response.data?.lists || []);
    } catch (error) {
      console.error('Error fetching experience list:', error);
      // toast.error('Failed to fetch experience records');
    }
  };

  const handleExperienceInputChange = (key, value) => {
    setExperienceFormData(prev => {
      const updatedData = { ...prev, [key]: value };

      // 1. Validate against external JSON rule
      const rule = EXPValidationRules[key];
      if (rule) {
        if (rule.required && !value.trim()) {
          setexpErrors(prevErrors => ({
            ...prevErrors,
            [key]: rule.message
          }));
        } else if (rule.pattern && value) {
          const regex = new RegExp(rule.pattern);
          if (!regex.test(value)) {
            setexpErrors(prevErrors => ({
              ...prevErrors,
              [key]: rule.patternMessage || rule.message
            }));
          } else {
            setexpErrors(prevErrors => ({
              ...prevErrors,
              [key]: ''
            }));
          }
        } else {
          // Clear error if valid
          setexpErrors(prevErrors => ({
            ...prevErrors,
            [key]: ''
          }));
        }
      }

      // 2. Auto-calculate total years (if start_date/end_date)
      if (key === 'start_date' || key === 'end_date') {
        const startDate = new Date(key === 'start_date' ? value : updatedData.start_date);
        const endDate = new Date(key === 'end_date' ? value : updatedData.end_date);

        if (
          updatedData.start_date &&
          updatedData.end_date &&
          !isNaN(startDate) &&
          !isNaN(endDate)
        ) {
          if (endDate >= startDate) {
            const diffTime = endDate - startDate;
            const diffYears = (diffTime / (1000 * 60 * 60 * 24 * 365.25)).toFixed(2);
            updatedData.total_years = diffYears;
            setexpErrors(prev => ({ ...prev, end_date: '' }));
          } else {
            updatedData.total_years = '';
            setexpErrors(prev => ({
              ...prev,
              end_date: 'End date cannot be before start date.'
            }));
          }
        }
      }

      return updatedData;
    });
  };
  const handleExperienceSave = async () => {
    setexpErrors({});
    try {
      // Validate required fields
      const errors = {};

      if (!experienceFormData.job_title) {
        errors.job_title = 'Job Title is required';
      }

      if (!experienceFormData.organization) {
        errors.organization = 'Organization is required';
      }

      if (!experienceFormData.type) {
        errors.type = 'Type is required';
      }

      if (!experienceFormData.start_date) {
        errors.start_date = 'Start Date is required';
      }

      if (!experienceFormData.end_date) {
        errors.end_date = 'End Date is required';
      }

      if (Object.keys(errors).length > 0) {
        setexpErrors(errors);
        toastService.error('Please fill all required fields');
        return;
      }

      // Validate dates
      const startDate = new Date(experienceFormData.start_date);
      const endDate = new Date(experienceFormData.end_date);
      if (endDate < startDate) {
        toast.error('End date cannot be earlier than start date');
        return;
      }

      setSaving(prev => ({ ...prev, educationExperience: true }));

      if (editingExperienceId) {
        // Update existing experience
        await apiService.updateExperience(employeeData.id, editingExperienceId, experienceFormData);
        toast.success('Experience updated successfully');
      } else {
        // Create new experience
        await apiService.insertExperience(employeeData.id, experienceFormData);
        toast.success('Experience added successfully');
      }

      // Reset form and refresh list
      setExperienceFormData({
        job_title: '',
        organization: '',
        type: '',
        start_date: '',
        end_date: '',
        total_years: ''
      });
      setShowExperienceForm(false);
      setEditingExperienceId(null);
      await fetchExperienceList();

    } catch (error) {
      console.error('Error saving experience:', error);
      toast.error('Failed to save experience record');
    } finally {
      setSaving(prev => ({ ...prev, educationExperience: false }));
    }
  };

  const handleExperienceEdit = (experience) => {
    setExperienceFormData({
      job_title: experience.job_title || '',
      organization: experience.organization || '',
      type: experience.type || '',
      start_date: experience.start_date || '',
      end_date: experience.end_date || '',
      total_years: experience.total_years || ''
    });
    setEditingExperienceId(experience.id);
    setShowExperienceForm(true);
  };

  const handleExperienceDelete = (experienceId) => {
    setConfirmModal({
      show: true,
      message: "Are you sure you want to delete this experience record?",
      onConfirm: async () => {
        try {
          await apiService.deleteExperience(employeeData.id, experienceId);
          toast.success('Experience deleted successfully');
          await fetchExperienceList();
        } catch (error) {
          console.error('Error deleting experience:', error);
          toast.error('Failed to delete experience record');
        }
      }
    });
  };

  const handleExperienceCancel = () => {
    setexpErrors({})
    setExperienceFormData({
      job_title: '',
      organization: '',
      type: '',
      start_date: '',
      end_date: '',
      total_years: ''
    });
    setShowExperienceForm(false);
    setEditingExperienceId(null);
  };

  // Helper function to format type display
  const formatExperienceType = (type) => {
    return type === 'student' ? 'Education' : 'Job Experience';
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  const renderSectionHeader = (title, section, showAdd = false) => {
    // Define section-specific configurations
    const sectionConfig = {
      employeeIdentity: {
        hasAdd: true,
        hasEdit: false,
        addHandler: () => setShowKycForm(true)
      },
      educationExperience: {
        hasAdd: true,
        hasEdit: false,
        addHandler: () => setShowExperienceForm(true)
      },
      // Add more sections as needed
      employeeInfo: {
        hasAdd: false,
        hasEdit: true,
        addHandler: null
      },
      personalInfo: {
        hasAdd: false,
        hasEdit: true,
        addHandler: null
      },
      joiningDetails: {
        hasAdd: false,
        hasEdit: true,
        addHandler: null
      }
    };

    const config = sectionConfig[section] || { hasAdd: false, hasEdit: true, addHandler: null };

    return (
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="text-primary d-flex align-items-center mb-0 fw-bold">
          <MdDoubleArrow className='mr-1' />
          {title}
        </h6>
        <div className='d-flex align-item-center justify-content-center'>
          {/* Show Add button */}
          {showAdd && !editMode[section] && config.hasAdd && (
            <Button
              className="d-flex align-items-center"
              size='sm'
              variant="link"
              onClick={config.addHandler || (() => console.log(`Add new clicked for section: ${section}`))}
            >
              <FaPlus className="me-2" />
              Add New
            </Button>
          )}

          {/* Edit/Save/Cancel buttons */}
          {config.hasEdit && (
            <>
              {editMode[section] ? (
                // Show Save and Cancel when in edit mode
                <div className='d-flex align-item-center justify-content-center gap-2'>
                  <Button
                    variant="primary"
                    size="sm"
                    className=" fw-bold"
                    onClick={() => handleSave(section)}
                    disabled={
                      saving[section] ||
                      (section === "officialInfo" &&
                        (!companyFields.company_email || !companyFields.company_user_id))
                    }
                    style={{ width: '100px' }}
                  >
                    {saving[section] ? 'Saving...' : 'Save'}
                  </Button>
                  <Button
                    variant="secondary"
                    className='fw-bold'
                    size="sm"
                    style={{ width: '100px' }}
                    onClick={() => handleEditToggle(section)}
                    disabled={saving[section]}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                // Show Edit button when not in edit mode
                <Button
                  className="d-flex align-items-center"
                  variant="link"
                  size='sm'
                  onClick={() => handleEditToggle(section)}
                >
                  <FaEdit className="me-1" />
                  Edit
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  const renderEducationExperienceSection = () => (
    <div className="mb-5">
      {renderSectionHeader('Education & Experience', 'educationExperience', true)}

      {/* Verification Modal */}
      <DynamicModal
        show={showVerifyModal}
        onHide={handleVerifyCancel}
        title={`Verify ${verifyingExperience ? formatExperienceType(verifyingExperience.type) : 'Experience'}`}
        size="md"
        loading={saving.verification}
        fields={[
          {
            key: 'note',
            label: 'Verification Note',
            type: 'textarea',
            placeholder: 'Enter verification notes (required for verification)...',
            required: true,
            rows: 4,
            colLg: 12,
            helpText: 'Please provide details about the verification process.'
          }
        ]}
        buttons={[
          {
            label: "Cancel",
            variant: "secondary",
            action: "close",
            disabled: saving.verification,
          },
          {
            label: "Verify",
            variant: "primary",
            action: "submit",
            loadingLabel: "Verifying...",
            disabled: saving.verification,

          }
        ]}
        onSubmit={handleVerifySubmit}
        onCancel={handleVerifyCancel}
        initialData={{ note: '' }}
      />

      {/* Experience Form - Show when adding/editing */}
      {showExperienceForm && (
        <Card className="mb-3">
          <Card.Body>
            <h6 className="mb-3 text-primary">
              {editingExperienceId ? 'Edit Experience Record' : 'Add New Experience Record'}
            </h6>
            <Row>
              <Col xs={12} sm={6} lg={4} className="mb-3">
                <Form.Label className="fw-medium">
                  Type <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={experienceFormData.type}
                  onChange={(e) => handleExperienceInputChange('type', e.target.value)}
                  isInvalid={!!expErrors.type}
                >
                  <option value="">Select Type...</option>
                  <option value="student">Education</option>
                  <option value="job">Job Experience</option>
                </Form.Select>
                {expErrors.type && (
                  <Form.Text className="text-danger">{expErrors.type}</Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="mb-3">
                <Form.Label className="fw-medium">
                  {experienceFormData.type === 'student' ? 'Course/Degree' : 'Job Title'} <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={experienceFormData.job_title}
                  onChange={(e) => handleExperienceInputChange('job_title', e.target.value)}
                  placeholder={experienceFormData.type === 'student' ? 'Enter course/degree name' : 'Enter job title'}
                  maxLength={100}
                  isInvalid={!!expErrors.job_title}
                />
                {expErrors.job_title && (
                  <Form.Text className="text-danger">{expErrors.job_title}</Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="mb-3">
                <Form.Label className="fw-medium">
                  {experienceFormData.type === 'student' ? 'Institution' : 'Organization'} <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={experienceFormData.organization}
                  onChange={(e) => handleExperienceInputChange('organization', e.target.value)}
                  placeholder={experienceFormData.type === 'student' ? 'Enter institution name' : 'Enter organization name'}
                  maxLength={100}
                  isInvalid={!!expErrors.organization}
                />
                {expErrors.organization && (
                  <Form.Text className="text-danger">{expErrors.organization}</Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={3} className="mb-3">
                <Form.Label className="fw-medium">
                  Start Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={experienceFormData.start_date}
                  onChange={(e) => handleExperienceInputChange('start_date', e.target.value)}
                  isInvalid={!!expErrors.start_date}
                />
                {expErrors.start_date && (
                  <Form.Text className="text-danger">{expErrors.start_date}</Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={3} className="mb-3">
                <Form.Label className="fw-medium">
                  End Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={experienceFormData.end_date}
                  onChange={(e) => handleExperienceInputChange('end_date', e.target.value)}
                  isInvalid={!!expErrors.end_date}
                  min={experienceFormData.start_date ?
                    (() => {
                      const minDate = new Date(experienceFormData.start_date);
                      minDate.setMonth(minDate.getMonth() + 1);
                      return minDate.toISOString().split('T')[0];
                    })() :
                    undefined
                  }
                />
                {expErrors.end_date && (
                  <Form.Text className="text-danger">{expErrors.end_date}</Form.Text>
                )}
              </Col>

              <Col xs={12} sm={6} lg={3} className="mb-3">
                <Form.Label className="fw-medium">
                  Total Years <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={experienceFormData.total_years}
                  onChange={(e) => handleExperienceInputChange('total_years', e.target.value)}
                  placeholder="0.00"
                  disabled
                />
              </Col>
            </Row>

            <div className="d-flex gap-2">
              <Button
                variant="primary"
                size="sm"
                onClick={handleExperienceSave}
                disabled={saving.educationExperience || Object.values(expErrors).some(error => error)}
                style={{ width: '100px' }}
                className='fw-bold'
              >
                {saving.educationExperience ? 'Saving...' : (editingExperienceId ? 'Update' : 'Save')}
              </Button>
              <Button
                variant="secondary"
                size="sm"
                onClick={handleExperienceCancel}
                disabled={saving.educationExperience}
                style={{ width: '100px' }}
                className='fw-bold'
              >
                Cancel
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Experience List - Show existing records */}
      {experienceList.length > 0 ? (
        <div>
          {experienceList.map((experience, index) => (
            <Card key={experience.id} className="mb-3">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <h6 className="m-0 text-primary fw-bold">
                      {formatExperienceType(experience.type)} - {index + 1}
                      <Badge
                        bg={experience.verified ? "success" : "warning"}
                        className="ms-2 d-inline-flex align-items-center px-2 py-1"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {experience.verified ? (
                          <>
                            <FaCheck className="me-1" style={{ fontSize: "0.75rem" }} />
                            Verified
                          </>
                        ) : (
                          <>
                            <FaTimes className="me-1" style={{ fontSize: "0.75rem" }} />
                            Not Verified
                          </>
                        )}
                      </Badge>
                    </h6>
                    <small className="text-muted">
                      Created: {formatDate(experience.created_date)}
                      {experience.verified && experience.verified_by && (
                        <> | Verified by: {experience.verified_by.email}</>
                      )}
                    </small>
                  </div>
                  <div className="d-flex gap-2">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleExperienceEdit(experience)}
                      className='d-inline-flex align-items-center no-hover'
                    >
                      <FaEdit className="me-1" />
                      Edit
                    </Button>

                    {/* Show Verify button only if not verified */}
                    {!experience.verified && (
                      <Button
                        variant="outline-success"
                        size="sm"
                        onClick={() => handleVerifyExperience(experience)}
                        className='d-inline-flex align-items-center no-hover'
                      >
                        <FaCheckCircle className="me-1" />
                        Verify
                      </Button>
                    )}

                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleExperienceDelete(experience.id)}
                      className='d-inline-flex align-items-center no-hover'
                    >
                      <FaTrash className="me-1" />
                      Delete
                    </Button>
                  </div>
                </div>

                <Row>
                  <Col xs={12} sm={6} lg={3} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">Type</p>
                      <p className="fw-medium text-muted mb-0 p-2 rounded border">
                        {formatExperienceType(experience.type)}
                      </p>
                    </div>
                  </Col>

                  <Col xs={12} sm={6} lg={3} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">
                        {experience.type === 'student' ? 'Course/Degree' : 'Job Title'}
                      </p>
                      <p className="fw-medium text-muted mb-0 p-2 rounded border">
                        {experience.job_title || '-'}
                      </p>
                    </div>
                  </Col>

                  <Col xs={12} sm={6} lg={3} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">
                        {experience.type === 'student' ? 'Institution' : 'Organization'}
                      </p>
                      <p className="fw-medium text-muted mb-0 p-2 rounded border">
                        {experience.organization || '-'}
                      </p>
                    </div>
                  </Col>

                  <Col xs={12} sm={6} lg={3} className="mb-2">
                    <div>
                      <p className="fw-medium mb-1">Duration</p>
                      <p className="fw-medium text-muted mb-0 p-2 rounded border">
                        {formatDate(experience.start_date)} - {formatDate(experience.end_date)}
                        <small className='ml-2'>({experience.total_years} years)</small>
                      </p>
                    </div>
                  </Col>
                </Row>

                {/* Show note only if it exists and is verified */}
                {experience.note && experience.verified && (
                  <Row className="mt-2">
                    <Col xs={12}>
                      <div>
                        <p className="fw-medium mb-1">Verification Note</p>
                        <p className="fw-medium text-muted mb-0 p-2 rounded border bg-light">
                          {experience.note}
                        </p>
                      </div>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>
          ))}
        </div>
      ) : (
        !showExperienceForm && (
          <div className="text-center py-4">
            <Button
              variant="outline-primary"
              onClick={() => setShowExperienceForm(true)}
              className='d-inline-flex align-items-center no-hover'
            >
              <FaPlus className="me-2" />
              Add First Record
            </Button>
          </div>
        )
      )}
    </div>
  );

  const handleVerifyExperience = (experience) => {
    setVerifyingExperience(experience);
    setVerifyingExperienceId(experience.id);
    setShowVerifyModal(true);
  };

  const handleVerifySubmit = async (formData) => {
    try {
      setSaving(prev => ({ ...prev, verification: true }));

      await apiService.verifyExperience(employeeData.id, verifyingExperienceId, {
        note: formData.note
      });

      toast.success('Experience verified successfully');
      setShowVerifyModal(false);
      setVerifyingExperienceId(null);
      setVerifyingExperience(null);

      // Refresh the experience list
      await fetchExperienceList();

    } catch (error) {
      console.error('Error verifying experience:', error);
      toast.error('Failed to verify experience');
    } finally {
      setSaving(prev => ({ ...prev, verification: false }));
    }
  };

  const handleVerifyCancel = () => {
    setShowVerifyModal(false);
    setVerifyingExperienceId(null);
    setVerifyingExperience(null);
  };
  const handleApproval = async (isApprove) => {
    try {
      setSaving(prev => ({
        ...prev,
        approveAction: isApprove,
        rejectAction: !isApprove
      }));

      const profileId = employeeData?.id;
      const status = employeeData?.onboarding_status?.status;

      const response = await employeeApprovalService.approveEmployee(profileId, status, isApprove);

      if (response?.type === "success") {
        toast.success(response.message || "Successfully submitted");
        if (isApprove) {
          dispatch(getRoles());
          dispatch(getSingleUser(user_id));
          setEmployeeData(user);
          setOriginalData(user);
        } else {
          navigate('/user-management');
        }
      } else {
        toastService.error(response.message || "Something went wrong");
      }
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toastService.error(errorMessage);
    } finally {
      setSaving(prev => ({
        ...prev,
        approveAction: false,
        rejectAction: false
      }));
    }
  };
  if (loading) {
    return (
      <Base>
        <Container>
          <Loader />
        </Container>
      </Base>
    );
  }

  return (
    <Base>
      <Container>
        <Row>
          <Col className="mr-auto text-center">
            <Breadcrumb>
              <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: '/' }}>Dashboard</Breadcrumb.Item>
              <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: '/user-management' }}>User List</Breadcrumb.Item>
              <Breadcrumb.Item active>
                User management
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-white border-bottom p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="position-relative me-3">
                      {employeeData.photo ? (
                        <Image
                          src={employeeData.photo}
                          alt="Employee profile"
                          width={64}
                          height={64}
                          roundedCircle
                          className="border border-3 border-blue p-1 object-fit-cover"
                          style={{ width: '64px', height: '64px', objectFit: 'cover' }}
                        />
                      ) : (
                        <FaUserCircle
                          size={64}
                          className="text-secondary border border-3 border-blue rounded-circle p-1"
                        />
                      )}
                    </div>
                    <div>
                      <h4 className="mb-1 fw-semibold">{truncateText(employeeData.name, 50)}</h4>
                      <div className="d-flex align-items-center">
                        <span className="text-muted small">{truncateText(employeeData.email, 50)}</span>
                        {employeeData?.onboarding_status?.status === 1 ? (
                          <Badge bg="success" className="ms-2">Active</Badge>
                        ) : employeeData?.onboarding_status?.status === 3 ? (
                          <Badge bg="info" className="ms-2">Temporary Account Active</Badge>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className='d-flex align-item-center flex-wrap gap-2'>

                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      className="d-none"
                      onChange={handlePhotoChange}
                    />
                    <Button
                      className="d-flex align-items-center justify-content-between fw-bold"
                      variant="primary"
                      size="sm"
                      onClick={() => fileInputRef.current.click()}
                    >
                      <span className="me-auto pe-1"><IoCameraOutline /></span>
                      <span className="mx-auto">Update Photo</span>
                    </Button>
                  </div>
                </div>
                {(employeeData?.onboarding_status?.status === 0 || employeeData?.onboarding_status?.status === 3) && (
                  <div className="p-3 mt-3 border-top">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">

                      {/* Left: Heading and Dynamic Workflow */}
                      <div>
                        <h6 className="text-primary fw-semibold mb-3  d-flex align-items-center">
                          <MdDoubleArrow className="mr-1" />
                          {employeeData.onboarding_status.status === 0 ? 'Temporary Approval' : 'Permanent Approval'}

                        </h6>
                        <div className="d-flex align-items-center overflow-auto pb-2" style={{ gap: '1rem' }}>
                          {Object.values(employeeData.progress || {})
                            .sort((a, b) => b.level - a.level) // ⬅️ sort by level descending
                            .map((step, index, array) => (
                              <React.Fragment key={step.level}>
                                <div className="d-flex align-items-center" style={{ minWidth: 'max-content', gap: '0.5rem' }}>
                                  <div className="d-flex flex-column align-items-center">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center"
                                      style={{
                                        width: '32px',
                                        height: '32px',
                                        backgroundColor: step.progress === 1 ? '#28a745' : '#dee2e6',
                                        color: step.progress === 1 ? '#fff' : '#6c757d',
                                      }}
                                    >
                                      {step.progress === 1 ? <FaCheck size={14} /> : <FaUser size={14} />}
                                    </div>
                                    <p className="text-muted mt-1 mb-0 text-center" style={{ fontSize: '0.75rem' }}>{step.name}</p>
                                  </div>
                                  {index < array.length - 1 && (
                                    <div
                                      style={{
                                        width: '48px',
                                        height: '2px',
                                        backgroundColor: step.progress === 1 ? '#28a745' : '#dee2e6',
                                      }}
                                    ></div>
                                  )}
                                </div>
                              </React.Fragment>
                            ))}
                        </div>
                      </div>

                      {/* Right: Action Buttons */}
                      <div className="d-flex gap-2 mt-2 mt-md-0">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="fw-bold no-hover"
                          style={{ width: '100px' }}
                          disabled={saving.approveAction || saving.rejectAction}
                          onClick={() => handleApproval(true)}
                        >
                          {saving.approveAction ? 'Approving...' : 'Approve'}
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="fw-bold no-hover"
                          style={{ width: '100px' }}
                          disabled={saving.approveAction || saving.rejectAction}
                          onClick={() => handleApproval(false)}
                        >
                          {saving.rejectAction ? 'Rejecting...' : 'Reject'}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </Card.Header>
              <Card.Body className="d-flex flex-column p-0" style={{ height: '70vh' }}> {/* Set a fixed height */}
                <div className="sticky-top bg-white border-bottom !z-0">
                  <Tabs
                    activeKey={activeTab}
                    onSelect={(key) => setActiveTab(key)}
                    className="border-bottom-0 custom-tabs px-3 pt-2"
                    variant="underline"
                  >
                    <Tab eventKey="general" title="General" />
                    <Tab eventKey="employment" title="Employment" />
                    <Tab eventKey="other" title="Other" />
                  </Tabs>
                </div>

                {/* Scrollable Content Area */}
                <div className="flex-grow-1 overflow-auto">
                  <div className="tab-content">
                    {activeTab === 'general' && (
                      <div className="p-3">
                        {renderSection('employeeInfo')}
                        {renderSection('officialInfo')}
                        {/* {renderSection('personalInfo')} */}
                        <div className="mb-5">
                          {renderEmployeeIdentitySection()}
                        </div>
                      </div>
                    )}

                    {activeTab === 'employment' && (
                      <div className="p-3">
                        {renderSection('joiningDetails')}
                        {renderEducationExperienceSection()}
                      </div>
                    )}

                    {activeTab === 'other' && (
                      <div className="p-3">
                        {/* Remarks */}
                        <div>
                          {renderSectionHeader('Remarks', 'remarks')}
                          {editMode.remarks ? (
                            <Form.Control
                              as="textarea"
                              rows={4}
                              value={employeeData.remark || ''}
                              onChange={(e) => handleInputChange('remark', e.target.value)}
                              placeholder="Add remarks..."
                            />
                          ) : (
                            <p className="text-muted fst-italic small">
                              {employeeData.remark || 'No remarks added yet.'}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <DynamicModal
        show={confirmModal.show}
        onHide={() => setConfirmModal({ ...confirmModal, show: false })}
        title="Confirm Delete"
        buttons={[
          {
            label: 'Cancel',
            variant: 'secondary',
            action: 'custom',
            onClick: () => setConfirmModal({ ...confirmModal, show: false })
          },
          {
            label: 'Delete',
            variant: 'danger',
            action: 'custom',
            onClick: async () => {
              setConfirmModal({ ...confirmModal, show: false });
              if (confirmModal.onConfirm) {
                await confirmModal.onConfirm();
              }
            }
          }
        ]}
      >
        <p>{confirmModal.message}</p>
      </DynamicModal>
      <Modal show={showCreateModal} onHide={handleCreateModalClose} centered className='border-0'>
        <Modal.Header closeButton>
          <Modal.Title>Create New {createModalData.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="fw-bold">
              {createModalData.label} <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={createModalData.name}
              onChange={(e) => setCreateModalData(prev => ({ ...prev, name: e.target.value }))}
              placeholder={`Enter ${createModalData.label} name`}
              isInvalid={!!createModalErrors.name}
              maxLength={80}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !creatingItem) {
                  handleCreateModalSubmit();
                }
              }}
            />
            <Form.Control.Feedback type="invalid">
              {createModalErrors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCreateModalClose}
            disabled={creatingItem}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleCreateModalSubmit}
            disabled={creatingItem || !createModalData.name.trim()}
          >
            {creatingItem ? 'Creating...' : 'Create'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Base>
  );
}

export default Employees;